export const cidades = [
  'Campo Grande',
  'Água Clara',
  'Alcinópolis',
  'Amambai',
  'Anastácio',
  'Anaurilândia',
  'Angélica',
  'Aparecida do Taboado',
  'Aquidauana',
  'Aral Moreira',
  'Bataguassu',
  'Batayporã',
  'Bela Vista',
  'Bandeirantes',
  'Bodoquena',
  'Bonito',
  'Brasilândia',
  'Caarapó',
  'Camapuã',
  'Caracol',
  'Cassilândia',
  'Chapadão do Sul',
  'Corguinho',
  'Coronel Sapucaia',
  'Corumbá',
  'Costa Rica',
  'Coxim',
  'Deodápolis',
  'Dois Irmãos do Buriti',
  'Douradina',
  'Dourados',
  'Eldorado',
  'Fátima do Sul',
  'Figueirão',
  'Glória de Dourados',
  'Guia Lopes da Laguna',
  'Iguatemi',
  'Inocência',
  'Itaporã',
  'Itaquiraí',
  'Ivinhema',
  'Japorã',
  'Jaraguari',
  'Jardim',
  'Jateí',
  'Juti',
  'Ladário',
  'Laguna Carapã',
  'Maracaju',
  'Miranda',
  'Mundo Novo',
  'Naviraí',
  'Nioaque',
  'Nova Alvorada do Sul',
  'Nova Andradina',
  'Novo Horizonte do Sul',
  'Paraíso das Águas',
  'Paranaíba',
  'Paranhos',
  'Pedro Gomes',
  'Ponta Porã',
  'Porto Murtinho',
  'Ribas do Rio Pardo',
  'Rio Brilhante',
  'Rio Negro',
  'Rio Verde de Mato Grosso',
  'Rochedo',
  'Santa Rita do Pardo',
  'São Gabriel do Oeste',
  'Selvíria',
  'Sete Quedas',
  'Sidrolândia',
  'Sonora',
  'Tacuru',
  'Taquarussu',
  'Terenos',
  'Três Lagoas',
  'Vicentina',
];

export const tiposTelha = ['Fibromadeira', 'Sem Estrutura', 'Zinco'];
